import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "max-w-4xl mx-auto" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "flex border-b border-gray-200 overflow-x-auto whitespace-nowrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "space-y-0.5" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-lg font-medium text-gray-800" }
const _hoisted_10 = {
  key: 0,
  class: "px-6 py-4 bg-gray-50 border-t border-gray-200 text-left"
}
const _hoisted_11 = { class: "text-gray-600 leading-relaxed whitespace-pre-line" }

import { ref, computed } from 'vue';

// FAQ分类Tabs数据

export default /*@__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const tabs = ref([
  {
    name: '企业',
    data: [
      {
        question: "北境骑团集团的使命是什么？",
        answer: "我们的使命是\"并肩前行，探索骑行乐趣\"。"
      },
      {
        question: "公司为什么命名为\"北境骑团\"？",
        answer: "北境骑团意谓\"并肩前行，探索骑行乐趣\"，喻意我们的平台为骑行爱好者开启财富之门。"
      }
    ]
  },
  {
    name: '产品服务',
    data: [
      {
        question: "北境骑团提供哪些核心产品和服务？",
        answer: "自行车、头盔、服装"
      }
    ]
  }
  
]);

// 响应式数据 - 当前激活的Tab索引
const activeTab = ref(0);

// 响应式数据 - 当前展开的问题索引
const expandedIndex = ref(-1);

// 计算属性 - 获取当前激活Tab的数据
const activeTabData = computed(() => {
  return tabs.value[activeTab.value].data || [];
});

// 方法 - 切换折叠面板状态
const toggleAccordion = (index: number) => {
  expandedIndex.value = expandedIndex.value === index ? -1 : index;
};

// 监听Tab变化，重置折叠面板状态
const handleTabChange = (index: number) => {
  activeTab.value = index;
  expandedIndex.value = -1; // 切换Tab时重置展开状态
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-3xl font-bold text-gray-900 mb-8" }, "常见问题", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              onClick: ($event: any) => (handleTabChange(index)),
              class: _normalizeClass(["px-4 py-3 text-sm font-medium transition-colors duration-200 focus:outline-none", {
              'text-blue-600 border-b-2 border-blue-600': activeTab.value === index,
              'text-gray-500 hover:text-gray-700': activeTab.value !== index
            }])
            }, _toDisplayString(tab.name), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTabData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["border border-gray-200 rounded-md overflow-hidden transition-all duration-200", { 'shadow-md': expandedIndex.value === index }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (toggleAccordion(index)),
                  class: _normalizeClass(["w-full flex justify-between items-center px-6 py-4 text-left bg-white hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-200", { 'rounded-b-none': expandedIndex.value === index }])
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.question), 1),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["h-5 w-5 text-gray-500 transition-transform duration-200 ease-in-out", { 'transform rotate-180': expandedIndex.value === index }]),
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, _cache[0] || (_cache[0] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ]), 2))
                ], 10, _hoisted_8),
                _createVNode(_Transition, { name: "collapse" }, {
                  default: _withCtx(() => [
                    (expandedIndex.value === index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(item.answer), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})